<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f026-02.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The plaque commemorating the ‘Dicky’s Dash’ trench raid</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 40_chapter012.vue?6d1469dc